module.exports = __webpack_public_path__ + "img/geetaji.00b3fafe.jpg";